namespace Matrix.Rebalancer {
    export interface HoldingClassWeightForm {
        AccountCode: FormatServiceLookupEditor;
        SecurityId: FormatServiceLookupEditor;
        Weight: Serenity.DecimalEditor;
        ExposureCurrency: FormatLookupEditor;
        Class1: Serenity.StringEditor;
        Class2: Serenity.StringEditor;
        Class3: Serenity.StringEditor;
        Class4: Serenity.StringEditor;
        Class5: Serenity.StringEditor;
        Class6: Serenity.StringEditor;
        Class7: Serenity.StringEditor;
        Class8: Serenity.StringEditor;
        Class9: Serenity.StringEditor;
        Class10: Serenity.StringEditor;
        Version: StaticTextBlock;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
    }

    export class HoldingClassWeightForm extends Serenity.PrefixedContext {
        static formKey = 'Rebalancer.HoldingClassWeight';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!HoldingClassWeightForm.init)  {
                HoldingClassWeightForm.init = true;

                var s = Serenity;
                var w0 = FormatServiceLookupEditor;
                var w1 = s.DecimalEditor;
                var w2 = FormatLookupEditor;
                var w3 = s.StringEditor;
                var w4 = StaticTextBlock;
                var w5 = ReadOnlyDateTime;

                Q.initFormType(HoldingClassWeightForm, [
                    'AccountCode', w0,
                    'SecurityId', w0,
                    'Weight', w1,
                    'ExposureCurrency', w2,
                    'Class1', w3,
                    'Class2', w3,
                    'Class3', w3,
                    'Class4', w3,
                    'Class5', w3,
                    'Class6', w3,
                    'Class7', w3,
                    'Class8', w3,
                    'Class9', w3,
                    'Class10', w3,
                    'Version', w4,
                    'CreatedBy', w4,
                    'CreatedWhen', w5,
                    'UpdatedBy', w4,
                    'UpdatedWhen', w5
                ]);
            }
        }
    }
}
